var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2832 16.684L24.8165 22.5173C24.6415 24.3023 24.5015 25.6673 21.3399 25.6673H6.66318C3.50152 25.6673 3.36152 24.3023 3.18652 22.5173L2.71985 16.684C2.62652 15.7157 2.92985 14.8173 3.47818 14.129C3.48985 14.1173 3.48985 14.1173 3.50152 14.1057C4.14318 13.324 5.11152 12.834 6.19652 12.834H21.8065C22.8915 12.834 23.8482 13.324 24.4782 14.0823C24.4899 14.094 24.5015 14.1057 24.5015 14.1173C25.0732 14.8057 25.3882 15.704 25.2832 16.684Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 13.3348V7.3265C4.07812 3.35983 5.06979 2.36816 9.03646 2.36816H10.5181C11.9998 2.36816 12.3381 2.8115 12.8981 3.55816L14.3798 5.5415C14.7531 6.0315 14.9748 6.33483 15.9665 6.33483H18.9415C22.9081 6.33483 23.8998 7.3265 23.8998 11.2932V13.3815",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.834H16.9967",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenIcon);
export default __webpack_public_path__ + "static/media/folder-open-icon.09c0f1ca5c2b7a9df1aededffb27e41c.svg";
export { ForwardRef as ReactComponent };